import { render, staticRenderFns } from "./DuplicateEnquiries.vue?vue&type=template&id=3403bb9a&scoped=true"
import script from "./DuplicateEnquiries.vue?vue&type=script&lang=js"
export * from "./DuplicateEnquiries.vue?vue&type=script&lang=js"
import style0 from "./DuplicateEnquiries.vue?vue&type=style&index=0&id=3403bb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3403bb9a",
  null
  
)

export default component.exports